import { createContext, useContext } from "react";

/**
 * Lets tooling that renders OUTSIDE a collab field's DOM (React portals:
 * annotation lightbox, overlap picker, future modals) declare that the user
 * is still working on that field, so the field lock is held deterministically
 * instead of guessed at via focus/blur.
 *
 * Works because React portals escape the DOM tree but NOT the React tree —
 * this context, provided by CollabFieldWrapper (blockGenerators), reaches the
 * portaled lightbox without any valuePath plumbing.
 *
 * Shape: { setEngaged(bool) } — engaged=true re-asserts the lock and blocks
 * release; engaged=false lets the normal blur/grace release flow resume.
 * null when the block isn't collab-editable (legacy pages, viewers) — every
 * consumer must handle that.
 */
export const CollabFieldEngagementContext = createContext(null);

export const useCollabFieldEngagementContext = () => useContext(CollabFieldEngagementContext);
